import CLOUDALFA_EXT_1 from "./CLOUDALFA_EXT_1";

export default {
  CLOUDALFA_EXT_1,
};
